import { apiClient } from './apiClient'
import { API_ENDPOINTS } from '../config/api'
import { db } from '../lib/database'
import { userActivityService } from './userActivityService'

export const userService = {
  getAccountDetails: () => {
    const fetchFromApi = () => {
      return apiClient.get(API_ENDPOINTS.auth.account).then(response => {
        const user = response.data.data || response.data
        if (user?.id) {
          return db.userProfile.put({ ...user, id: 'currentUser' }).then(() => response)
        }
        return response
      })
    }

    if (navigator.onLine) {
      return fetchFromApi().catch(() => {
        return db.userProfile.get('currentUser').then(localUser => {
          if (localUser) return { data: { data: localUser } }
          throw new Error('User data not available offline.')
        })
      })
    } else {
      return db.userProfile.get('currentUser').then(localUser => {
        if (localUser) return { data: { data: localUser } }
        throw new Error('You are offline and profile data is not saved locally.')
      })
    }
  },

  updateAccountDetails: (userData) => {
    return userActivityService.checkUserActivity().then(isUserActive => {
      if (!isUserActive) {
        throw new Error('User account is inactive')
      }

      const isFormData = userData instanceof FormData
      const config = isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}

      return apiClient.post('/v1/auth/profile', userData, config).then(response => {
        const updatedUser = response.data.data || response.data
        if (updatedUser) {
          return db.userProfile.put({ ...updatedUser, id: 'currentUser' }).then(() => updatedUser)
        }
        return updatedUser
      })
    })
  },

  changePassword: (payload) => {
    return userActivityService.checkUserActivity().then(isUserActive => {
      if (!isUserActive) {
        return Promise.reject({ 
          response: { data: { message: 'User account is inactive' } } 
        })
      }
      return apiClient.post(API_ENDPOINTS.auth.changePassword, payload, { suppressToast: true })
        .then(response => {
          if (response.data && response.data.status === false) {
            return Promise.reject({ response: { data: response.data } })
          }
          return response
        })
    })
  }
}